/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class FordCreditApprovalClientService extends __BaseService {
  static readonly FordCreditApprovalByEntityIdByEntityidGETPath = '/api/FordCreditApproval/FordCreditApprovalByEntityId/{entityId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param entityId undefined
   */
  FordCreditApprovalByEntityIdByEntityidGETResponse(entityId: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FordCreditApproval/FordCreditApprovalByEntityId/${entityId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param entityId undefined
   */
  FordCreditApprovalByEntityIdByEntityidGET(entityId: string): __Observable<null> {
    return this.FordCreditApprovalByEntityIdByEntityidGETResponse(entityId).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module FordCreditApprovalClientService {
}

export { FordCreditApprovalClientService }
